import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import Small from 'UIComponents/elements/Small';
import UITable from 'UIComponents/table/UITable';
// @ts-expect-error dependency missing types
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import ApprovalStepStatusText from '../sidebar/ApprovalStepStatusText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const approversWithStatus = props => {
  const {
    approversWithStepStatuses
  } = props;
  return /*#__PURE__*/_jsxs(UITable, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsxs("th", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.approvers"
          }), " (", approversWithStepStatuses.length, ")"]
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: approversWithStepStatuses.map(([approver, status]) => /*#__PURE__*/_jsx("tr", {
        "data-test-id": "approval-edit-review-row",
        children: /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsxs("span", {
            className: "align-center justify-between",
            children: [/*#__PURE__*/_jsxs("span", {
              className: "align-center",
              children: [/*#__PURE__*/_jsx(UIAvatar, {
                className: "m-right-4",
                hubSpotUserEmail: approver.email
              }), /*#__PURE__*/_jsxs("span", {
                className: "flex-column",
                children: [/*#__PURE__*/_jsx(FormattedName, {
                  givenName: approver.firstName,
                  familyName: approver.lastName
                }), /*#__PURE__*/_jsx(Small, {
                  use: "help",
                  children: approver.email
                })]
              })]
            }), /*#__PURE__*/_jsx(ApprovalStepStatusText, {
              approvalStepStatus: status
            })]
          })
        })
      }, approver.ownerId))
    })]
  });
};
export default approversWithStatus;